import { useEffect, useState } from "react";
import { convertFileSrc } from "@tauri-apps/api/core";
import { resolveResource } from "@tauri-apps/api/path";
import { isApp } from "../../utils/isApp";

/** Just need to add images in the src-tauri/assets folder for it to work as they
 * will be converted to use asset:// protocol and then converted to the correct
 * format to be used inside an image src attribute */
export const useTauriImage = (path: string) => {
  const [imageUrl, setImageUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!isApp) {
      setImageUrl(path);
      return;
    }

    const loadImage = async () => {
      try {
        const filePath = await resolveResource(path);
        const assetUrl = convertFileSrc(filePath);
        setImageUrl(assetUrl);
      } catch (error) {
        console.error(`Failed to load image ${path}:`, error);
      }
    };

    loadImage();
  }, [path]);

  return imageUrl;
};
